import axios from "axios";
import { OpenAPI } from "@propertelligent/client-api";

/**
 * Thin local client for GET /api/Message/{tenantId}/unread-count.
 * Kept out of the generated @propertelligent/client-api until backend CI regenerates the SDK.
 * Reuses OpenAPI.BASE/TOKEN so it points at the same origin + JWT as every other call.
 */

export interface TenantUnreadCountResponse {
  success?: { unreadCount: number };
  errors?: Record<string, string[]>;
}

const baseUrl = (): string => (typeof OpenAPI.BASE === "string" ? OpenAPI.BASE : "");

const authHeaders = (): Record<string, string> => {
  const token = typeof OpenAPI.TOKEN === "string" ? OpenAPI.TOKEN : undefined;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getTenantUnreadMessageCount = async (
  tenantId: number
): Promise<TenantUnreadCountResponse> => {
  const res = await axios.get(
    `${baseUrl()}/api/Message/${tenantId}/unread-count`,
    { headers: authHeaders() }
  );
  return res.data;
};
